import { Link } from "react-router-dom/cjs/react-router-dom";
import { getAlbumMediaImages } from "../../Gallery/galleryService";
import { useCallback, useContext, useEffect, useState } from "react";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../../App";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DasboardGallery = () => {
  const [createdAlbumData, setCreatedAlbumData] = useState([]);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [loading, setLoading] = useState(false);
  const defaultImage = "/images/no-data-found/feed_dummy.png";
  const defaultImageIndezOne = "/images/gallery/simg1.jpg";
  const defaultImageIndezTwo = "/images/gallery/simg2.jpg";
  const defaultImageIndezThree = "/images/gallery/bimg1.jpg";
  const defaultImageIndezFour = "/images/gallery/bimg2.jpg";
  const defaultImageIndezFive = "/images/gallery/simg3.jpg";
  const defaultImageIndezSix = "/images/gallery/simg4.jpg";
  const VideoDefaultURL = "/images/no-data-found/video_image.png";
  let vedioImage;
  useEffect(() => {
    getAllDetailsMeadia();
  }, []);

  const handleImageFeedError = useCallback((event) => {
    ;
    let type = determineMessageType(event);
    if (type == "video") {
      vedioImage = VideoDefaultURL;
    } else {
      event.target.src = defaultImage;
    }
  }, []);

  const determineMessageType = (messageData) => {
    const videoExtensions = /\.(mp4|avi|mov|mkv)$/i;
    if (videoExtensions.test(messageData)) {
      return "video";
    }
  };

  const handleImageError = useCallback((event, type) => {
    let newDefaultImage;
    switch (type) {
      case 0:
        newDefaultImage = defaultImageIndezOne;
        break;
      case 1:
        newDefaultImage = defaultImageIndezTwo;
        break;
      case 2:
        newDefaultImage = defaultImageIndezThree;
        break;
      case 3:
        newDefaultImage = defaultImageIndezFour;
        break;
      case 4:
        newDefaultImage = defaultImageIndezFive;
        break;
      case 5:
        newDefaultImage = defaultImageIndezSix;
        break;
      default:
        newDefaultImage = "";
    }

    event.target.src = newDefaultImage;
  }, []);

  // GET  Created  Album     .
  async function getAllDetailsMeadia() {
    setLoading(true);
    const param = {
      AlbumId: 0,
      LoggedInUserId: 0,
      OrgId: userDetails?.OrgId,
      AlbumMediaId: 0,
      PageNumber: 1,
      PageSize: 20,
      RecentPicture: 0,
      AlbumGUID: "",
    };
    try {
      const response = await getAlbumMediaImages(param);
      if (response?.Data) {
        let media = response?.Data?.orgAlbums;
        setCreatedAlbumData(media);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST?.DashboardGallery);
    }
  }

  const renderMedia = (media) => {
    const mediaPath = media?.MediaPath;
    const isVideo =
      mediaPath?.toLowerCase().endsWith(".mp4") ||
      mediaPath?.toLowerCase().endsWith(".mov");

    return isVideo ? (
      <video
        className="w-100"
        src={mediaPath}
        poster={defaultImage}
        controls
        playsInline
        muted
      // autoPlay
      // loop
      />
    ) : (
      <img
        src={mediaPath || defaultImage}
        onError={handleImageFeedError}
        className="w-100"
        alt="media"
      />
    );
  };

  return (
    <div className="card firstcard">
      <div className="">
      <div className="custom-tab-1 custom-tab-11">
      <strong className="upcome">Gallery</strong>
        <Link to="/Gallery" className="more-icon">
          <i className="fa fa-angle-right"></i>
        </Link>
      <div className="col-md-12">        
        <div className="row proin proin22 g-2 mt-1">
          <div className="col-xl-5 col-5">
            <div className="row g-2">
              <div className="col-xl-12">
                <div className="imgdiv">

                  {loading ? (
                    <Skeleton height={60} width="100%" />
                  ) : (
                    <img
                      src={
                        determineMessageType(createdAlbumData[0]?.MediaPath) ==
                          "video"
                          ? VideoDefaultURL
                          : createdAlbumData[0]?.MediaPath || defaultImage
                      }
                      onError={() =>
                        handleImageFeedError(createdAlbumData[0]?.MediaPath)
                      }
                      className="w-100"
                    />
                  )}
                </div>
              </div>
              <div className="col-xl-12">
                <div className="imgdiv">
                  {loading ? (
                    <Skeleton height={60} width="100%" />
                  ) : (
                    <img
                      src={
                        determineMessageType(createdAlbumData[1]?.MediaPath) ==
                          "video"
                          ? VideoDefaultURL
                          : createdAlbumData[1]?.MediaPath || defaultImage
                      }
                      onError={handleImageFeedError}
                      className="w-100"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-7 col-7">
            <div className="imgdiv">
              {loading ? (
                <Skeleton height={128} width="100%" />
              ) : (
                <img
                  src={
                    determineMessageType(createdAlbumData[2]?.MediaPath) ==
                      "video"
                      ? VideoDefaultURL
                      : createdAlbumData[2]?.MediaPath || defaultImage
                  }
                  onError={handleImageFeedError}
                  className="w-100"
                />
              )}
            </div>
          </div>
        </div>
        <div className="row proin mt-0 g-2">
          <div className="col-xl-7 col-7">
            <div className="imgdiv">
              {loading ? (
                <Skeleton height={128} width="100%" />
              ) : (
                <img
                  src={
                    determineMessageType(createdAlbumData[3]?.MediaPath) ==
                      "video"
                      ? VideoDefaultURL
                      : createdAlbumData[3]?.MediaPath || defaultImage
                  }
                  onError={handleImageFeedError}
                  className="w-100"
                />
              )}
            </div>
          </div>
          <div className="col-xl-5 col-5">
            <div className="row g-2">
              <div className="col-xl-12">
                <div className="imgdiv">
                  {loading ? (
                    <Skeleton height={60} width="100%" />
                  ) : (
                    <img
                      src={
                        determineMessageType(createdAlbumData[4]?.MediaPath) ==
                          "video"
                          ? VideoDefaultURL
                          : createdAlbumData[4]?.MediaPath || defaultImage
                      }
                      onError={handleImageFeedError}
                      className="w-100"
                    />
                  )}
                </div>
              </div>
              <Link to={"Gallery"} className="text-white">
                <div className="col-xl-12">
                  <div className="imgdiv lastimgdiv dash-lastdiv">
                    <img
                      src={
                        determineMessageType(createdAlbumData[5]?.MediaPath) ==
                          "video"
                          ? VideoDefaultURL
                          : createdAlbumData[5]?.MediaPath || defaultImage
                      }
                      onError={handleImageFeedError}
                      className="w-100"
                    />
                    <div>
                      <span>
                        View more
                      </span>
                    </div>
                  </div>


                </div></Link>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </div>
  );
};

export default DasboardGallery;
